import { render, staticRenderFns } from "./AppEditionList.vue?vue&type=template&id=3c59ce25&scoped=true&"
import script from "./AppEditionList.vue?vue&type=script&lang=js&"
export * from "./AppEditionList.vue?vue&type=script&lang=js&"
import style0 from "./AppEditionList.vue?vue&type=style&index=0&id=3c59ce25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c59ce25",
  null
  
)

export default component.exports